export const reservasPanels = {
  // OtaMessages.vue
  ota: {
    appTitle: "Activer les messages OTA",
    installIntro:
      "Pour répondre à vos clients Booking.com / Airbnb depuis WA Checkin, vous devez installer l'application",
    installIntroTail: "sur le logement.",
    installBtn: "Installer la messagerie OTA",
    installing: "Installation du module de messagerie…",
    retryLink: "J'ai déjà installé l'application, vérifier à nouveau",
    loading: "Chargement des messages OTA…",
    empty: "Aucun message OTA pour cette réservation.",
    modeAi: "IA",
    modeManual: "Manuel",
    predefinedHeader: "Réponses rapides",
    predefinedEmpty: "Aucune réponse correspondante.",
    inputPlaceholder: "Saisissez un message ou utilisez / pour les réponses rapides...",
    attachTitle: "Joindre une image",
    senderGuest: "Client",
    senderProperty: "Logement",
    senderSystem: "Système",
    senderUnknown: "Inconnu",
    fileFallback: "fichier",
    toastTitle: "Messages OTA",
    errorTitle: "Erreur",
    loadError: "Impossible de charger les messages OTA.",
    modeErrorDetail: "Impossible d'identifier la conversation OTA. Essayez de recharger la page.",
    modeManualOnTitle: "Mode manuel activé",
    modeAiOnTitle: "Agent IA activé",
    modeManualOnDetail: "Vous répondrez aux messages manuellement",
    modeAiOnDetail: "Le bot répondra automatiquement",
    modeChangeError: "Impossible de changer le mode de la conversation OTA",
    sendError: "Impossible d'envoyer le message OTA.",
    onlyImagesTitle: "Images uniquement",
    onlyImagesDetail: "Les OTA n'autorisent que l'envoi d'images.",
    imageTooBigTitle: "Image trop volumineuse",
    imageTooBigDetail: "L'image ne peut pas dépasser 5 Mo.",
    installNoProperty: "Aucun établissement connecté à Channex n'a été trouvé.",
    installOk: "Application installée avec succès.",
    installError: "Impossible d'installer l'application.",
  },

  // ReservationNotes.vue
  notes: {
    composerPlaceholder: "Rédigez une note interne…",
    saveHint: "⌘ / Ctrl + Entrée pour enregistrer",
    saving: "Enregistrement…",
    addNote: "Ajouter une note",
    loading: "Chargement des notes…",
    emptyTitle: "Aucune note pour le moment",
    emptyText: "Ajoutez la première note interne depuis le champ ci-dessus.",
    cancel: "Annuler",
    save: "Enregistrer",
    team: "Équipe",
    confirmDelete: "Supprimer ?",
    yes: "Oui",
    no: "Non",
    editTitle: "Modifier",
    deleteTitle: "Supprimer",
    loadError: "Impossible de charger les notes",
    added: "Note ajoutée",
    saveError: "Impossible d'enregistrer la note",
    updated: "Note mise à jour",
    updateError: "Impossible de mettre à jour la note",
    deleted: "Note supprimée",
    deleteError: "Impossible de supprimer la note",
  },

  // ReservationPaymentsPanel.vue
  payments: {
    pendingLabel: "En attente",
    paidLabel: "Encaissé",
    totalLabel: "Total",
    loading: "Chargement des paiements…",
    empty: "Aucun paiement n'a encore été enregistré.",
    addPayment: "Ajouter un paiement…",
    fullyPaid: "Réservation entièrement payée",
    recalcTitle: "Recalculer",
    sendWhatsappTitle: "Envoyer via WhatsApp",
    copyLinkTitle: "Copier le lien",
    editAction: "Modifier",
    deleteAction: "Supprimer",
    modalEditTitle: "Modifier le paiement",
    modalAddTitle: "Ajouter un paiement",
    amountLabel: "Montant à encaisser",
    fillRemaining: "Encaisser le reste ({amount})",
    methodLabel: "Mode de paiement",
    sendWhatsappCheck: "Envoyer le lien au client via WhatsApp",
    noteLabel: "Note (facultatif)",
    notePlaceholder: "Ex. : acompte, paiement à l'arrivée…",
    cancel: "Annuler",
    save: "Enregistrer",
    generateLink: "Générer le lien",
    registerPayment: "Enregistrer le paiement",
    deleteConfirmTitle: "Supprimer ce paiement ?",
    deleteText1: "Cela supprimera le paiement de",
    deleteLinkVoided: "Le lien de paiement sera annulé.",
    deleteIrreversible: "Cette action est irréversible.",
    deleteBtn: "Supprimer le paiement",
    sendConfirmTitle: "Envoyer le lien de paiement ?",
    sendText1: "Le client recevra via WhatsApp le lien de paiement pour",
    sendBtn: "Envoyer le lien",
    methodCash: "Espèces",
    methodCard: "Carte / terminal physique",
    methodTransfer: "Virement bancaire",
    methodOta: "Payé via OTA",
    statusPaid: "Encaissé",
    statusPending: "En attente",
    statusFailed: "Échoué",
    statusCancelled: "Annulé",
    loadError: "Impossible de charger les paiements.",
    amountRequired: "Saisissez un montant.",
    saveError: "Impossible d'enregistrer le paiement.",
    deleteError: "Impossible de le supprimer.",
    sendLinkError: "Impossible d'envoyer le lien.",
    recalcError: "Impossible de recalculer.",
  },

  // RoomAssignmentPanel.vue
  roomAssign: {
    title: "Attribuer une chambre",
    subWithUnitPre: "Cette réservation pour",
    subWithUnitPost: "n'a pas encore de chambre physique attribuée.",
    subNoUnit: "Cette réservation n'a pas encore de chambre physique attribuée.",
    loading: "Vérification de la disponibilité…",
    freePre: "Chambres disponibles pour",
    freePost: "Choisissez-en une et attribuez-la directement :",
    freeBadge: "Libre",
    assigning: "Attribution…",
    occupiedNote:
      "{count} chambre occupée à ces dates | {count} chambres occupées à ces dates",
    noneFreeTitle: "Aucune chambre libre pour ces dates.",
    noFreePre: "Toutes les chambres de",
    thisType: "ce type",
    noFreeMid:
      "sont occupées ou bloquées le {date}. Pour attribuer cette réservation,",
    reorganizeBold: "réorganisez les réservations",
    noFreeMid2: "pour ce type de chambre depuis le calendrier (le bouton",
    organizeBtn: "Organiser",
    noFreeTail: ") pour en libérer une.",
    tagMaintenance: "Maintenance",
    tagBlocked: "Bloquée",
    theseDates: "ces dates",
    occupied: "Occupée",
    assignedOk: "Chambre {label} attribuée avec succès.",
    assignError: "Impossible d'attribuer la chambre.",
    notifyError: "Erreur",
    notifyDone: "Terminé",
  },

  // GroupRoomsPanel.vue
  groupRooms: {
    heading: "Chambres de cette réservation",
    typesCount: "{count} type | {count} types",
    roomsCount: "{count} chambre | {count} chambres",
    guestsCount: "{count} client | {count} clients",
    totalLabel: "Total",
    viewingBadge: "Affichée",
    noRoomAssigned: "Aucune chambre attribuée",
    removeOneRoom: "Retirer une chambre",
    addOneRoom: "Ajouter une chambre",
    confirmRemove: "Retirer ?",
    yes: "Oui",
    no: "Non",
    cannotRemoveOnly: "Vous ne pouvez pas retirer la seule chambre",
    removeRoomFromBooking: "Retirer cette chambre de la réservation",
    updating: "Mise à jour…",
    theChannel: "le canal",
    otaManaged:
      "Cette chambre est gérée par {channel} : la quantité et le prix se modifient là-bas.",
    notifyError: "Erreur",
    notifyDone: "Terminé",
    qtyUpdated: "Quantité mise à jour",
    roomRemoved: "Chambre retirée de la réservation",
    updateError: "Impossible de mettre à jour la réservation. Veuillez réessayer.",
  },
};
